import { render } from "./TagsComponent.vue?vue&type=template&id=b2a21678&scoped=true"
import script from "./TagsComponent.vue?vue&type=script&lang=js"
export * from "./TagsComponent.vue?vue&type=script&lang=js"

import "./TagsComponent.vue?vue&type=style&index=0&id=b2a21678&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2a21678"]])

export default __exports__